import LocalizationForm from './LocalizationForm'

export default LocalizationForm
